/**
 * Safe method decorator that catches errors and prevents crashes
 * Usage: @SafeMethod() above any component method
 */
export function SafeMethod(fallbackValue?: any) {
  return function (
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]) {
      try {
        const result = originalMethod.apply(this, args);
        
        // Handle async methods (promises)
        if (result && typeof result.then === 'function') {
          return result.catch((error: any) => {
            console.error(`Error in async method ${propertyKey}:`, error);
            return fallbackValue;
          });
        }
        
        return result;
      } catch (error) {
        console.error(`Error in method ${propertyKey}:`, error);
        return fallbackValue;
      }
    };

    return descriptor;
  };
}

/**
 * Safe property accessor decorator that returns fallback on error
 * Usage: @SafeProperty(defaultValue) above any getter
 */
export function SafeProperty(fallbackValue?: any) {
  return function (
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {
    const originalGetter = descriptor.get;

    if (originalGetter) {
      descriptor.get = function () {
        try {
          return originalGetter.apply(this);
        } catch (error) {
          console.error(`Error accessing property ${propertyKey}:`, error);
          return fallbackValue;
        }
      };
    }

    return descriptor;
  };
}
